(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["barra-anuncio"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('anuncio-barra')) {
  customElements.define('anuncio-barra', class extends HTMLElement {
    connectedCallback() {
      this.mensajes = Array.from(this.querySelectorAll('[data-anun-mensaje]'));
      this.actual = 0;
      if (this.mensajes.length < 2 || this.dataset.rotar !== 'true') return;
      const velocidad = parseInt(this.dataset.velocidad, 10) || 4000;
      this.temporizador = setInterval(() => this.siguiente(), velocidad);
      this.addEventListener('mouseenter', () => { this.pausado = true; });
      this.addEventListener('mouseleave', () => { this.pausado = false; });
      document.addEventListener('shopify:block:select', (e) => {
        const i = this.mensajes.indexOf(e.target);
        if (i > -1) this.mostrar(i);
      });
    }
    disconnectedCallback() {
      clearInterval(this.temporizador);
    }
    siguiente() {
      if (this.pausado) return;
      this.mostrar((this.actual + 1) % this.mensajes.length);
    }
    mostrar(i) {
      this.mensajes[this.actual].classList.remove('anun-activo');
      this.actual = i;
      this.mensajes[this.actual].classList.add('anun-activo');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carrito-lateral"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('carrito-lateral')) return;

    const raiz = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    class CarritoLateral extends HTMLElement {
      connectedCallback() {
        this.seccion = this.dataset.seccion;
        this.modoEditor = Boolean(window.Shopify && window.Shopify.designMode);

        this.alClick = this.manejarClick.bind(this);
        this.alCambio = this.manejarCambio.bind(this);
        this.alTecla = (evento) => {
          if (evento.key === 'Escape') this.cerrar();
        };
        this.alHash = this.manejarHash.bind(this);
        this.alAgregado = () => this.refrescar().then(() => this.abrir());

        document.addEventListener('click', this.alClick, true);
        this.addEventListener('change', this.alCambio);
        window.addEventListener('hashchange', this.alHash);
        document.addEventListener('carrito:agregado', this.alAgregado);

        if (this.dataset.abrirAlAgregar === 'true') {
          this.conectarFichas();
          window.setTimeout(() => this.conectarFichas(), 0);
          document.addEventListener('DOMContentLoaded', () => this.conectarFichas());
        }

        if (this.modoEditor) {
          this.alSeleccionar = (evento) => {
            if (evento.detail && evento.detail.sectionId === this.seccion) this.abrir();
          };
          this.alDeseleccionar = (evento) => {
            if (evento.detail && evento.detail.sectionId === this.seccion) this.cerrar();
          };
          document.addEventListener('shopify:section:select', this.alSeleccionar);
          document.addEventListener('shopify:section:deselect', this.alDeseleccionar);
        }

        if (window.location.hash === '#carrito') this.manejarHash();
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.alClick, true);
        window.removeEventListener('hashchange', this.alHash);
        document.removeEventListener('carrito:agregado', this.alAgregado);
        document.removeEventListener('keydown', this.alTecla);
        if (this.alSeleccionar) document.removeEventListener('shopify:section:select', this.alSeleccionar);
        if (this.alDeseleccionar) document.removeEventListener('shopify:section:deselect', this.alDeseleccionar);
        document.body.classList.remove('carrito-lateral-sin-scroll');
      }

      conectarFichas() {
        document.querySelectorAll('ficha-producto').forEach((ficha) => {
          if (ficha.dataset.destino !== 'checkout') ficha.dataset.urlCarrito = '#carrito';
        });
      }

      manejarHash() {
        if (window.location.hash !== '#carrito') return;
        window.history.replaceState(null, '', window.location.pathname + window.location.search);

        document.querySelectorAll('.fp-boton--cargando').forEach((boton) => {
          boton.classList.remove('fp-boton--cargando');
          boton.disabled = false;
        });

        this.refrescar().then(() => this.abrir());
      }

      manejarClick(evento) {
        const objetivo = evento.target;
        if (!(objetivo instanceof Element)) return;

        const disparador = objetivo.closest('#cart-icon-bubble, [data-abrir-carrito]');
        if (disparador && !this.contains(disparador)) {
          evento.preventDefault();
          evento.stopPropagation();
          this.refrescar();
          this.abrir();
          return;
        }

        if (!this.contains(objetivo)) return;

        if (objetivo.closest('[data-cerrar-carrito]')) {
          evento.preventDefault();
          this.cerrar();
          return;
        }

        const cambio = objetivo.closest('[data-cambiar-cantidad]');
        if (cambio) {
          evento.preventDefault();
          this.actualizarGrupo(cambio.dataset.indices, Math.max(0, Number(cambio.dataset.cantidad)));
          return;
        }

        const upsell = objetivo.closest('[data-agregar-upsell]');
        if (upsell) {
          evento.preventDefault();
          const varianteUpsell = Number(upsell.dataset.agregarUpsell);
          if (varianteUpsell) this.agregar(varianteUpsell);
        }
      }

      manejarCambio(evento) {
        const campo = evento.target;
        if (!campo.matches || !campo.matches('[data-cantidad-input]')) return;
        const cantidad = Math.max(0, parseInt(campo.value, 10) || 0);
        this.actualizarGrupo(campo.dataset.indices, cantidad);
      }

      abrir() {
        if (this.classList.contains('carrito-lateral--abierto')) return;
        this.elementoPrevio = document.activeElement;
        this.classList.add('carrito-lateral--abierto');
        document.body.classList.add('carrito-lateral-sin-scroll');
        document.addEventListener('keydown', this.alTecla);
        const panel = this.querySelector('.carrito-lateral-panel');
        if (panel) window.setTimeout(() => panel.focus(), 50);
      }

      cerrar() {
        if (!this.classList.contains('carrito-lateral--abierto')) return;
        this.classList.remove('carrito-lateral--abierto');
        document.body.classList.remove('carrito-lateral-sin-scroll');
        document.removeEventListener('keydown', this.alTecla);
        if (this.elementoPrevio && this.elementoPrevio.focus) this.elementoPrevio.focus();
      }

      mostrarError(mensaje) {
        const error = this.querySelector('[data-error-carrito]');
        if (!error) return;
        error.textContent = mensaje || this.dataset.textoError;
        error.hidden = false;
      }

      peticion(ruta, cuerpo) {
        this.classList.add('carrito-lateral--cargando');
        return fetch(`${raiz()}${ruta}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(cuerpo)
        })
          .then((respuesta) => respuesta.json().then((datos) => ({ correcto: respuesta.ok, datos })))
          .then(({ correcto, datos }) => {
            if (!correcto) throw new Error(datos.description || datos.message);
            return this.refrescar();
          })
          .catch((problema) => {
            this.classList.remove('carrito-lateral--cargando');
            this.mostrarError(problema && problema.message);
          });
      }

      actualizarGrupo(indices, total) {
        const lista = this.querySelector('.carrito-lateral-lista');
        if (!lista || !indices) return;

        const cantidades = (lista.dataset.cantidades || '').split(',').map((valor) => Number(valor) || 0);
        const posiciones = indices.split(',').filter(Boolean).map(Number);
        if (posiciones.length === 0) return;

        posiciones.forEach((posicion) => {
          cantidades[posicion - 1] = 0;
        });
        cantidades[posiciones[0] - 1] = total;

        return this.peticion('cart/update.js', { updates: cantidades });
      }

      agregar(variante) {
        return this.peticion('cart/add.js', { items: [{ id: variante, quantity: 1 }] });
      }

      refrescar() {
        const secciones = [this.seccion];
        if (document.getElementById('cart-icon-bubble')) secciones.push('cart-icon-bubble');

        return fetch(`${raiz()}?sections=${secciones.join(',')}`)
          .then((respuesta) => respuesta.json())
          .then((datos) => {
            const lector = new DOMParser();

            if (datos[this.seccion]) {
              const documento = lector.parseFromString(datos[this.seccion], 'text/html');
              const nuevoPanel = documento.querySelector('.carrito-lateral-panel');
              const panel = this.querySelector('.carrito-lateral-panel');
              if (nuevoPanel && panel) panel.innerHTML = nuevoPanel.innerHTML;
            }

            if (datos['cart-icon-bubble']) {
              const documento = lector.parseFromString(datos['cart-icon-bubble'], 'text/html');
              const interior = documento.querySelector('.shopify-section');
              const burbuja = document.getElementById('cart-icon-bubble');
              if (interior && burbuja) burbuja.innerHTML = interior.innerHTML;
            }
          })
          .catch(() => {})
          .finally(() => this.classList.remove('carrito-lateral--cargando'));
      }
    }

    customElements.define('carrito-lateral', CarritoLateral);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faqpreguntas"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (document.documentElement.dataset.faqColumnasListo) return;
    document.documentElement.dataset.faqColumnasListo = 'true';

    document.addEventListener(
      'toggle',
      function (evento) {
        const item = evento.target;
        if (!(item instanceof HTMLDetailsElement) || !item.classList.contains('faq-columnas-item') || !item.open) return;

        const seccion = item.closest('.faq-columnas');
        if (!seccion || seccion.dataset.soloUno !== 'true') return;

        seccion.querySelectorAll('.faq-columnas-item[open]').forEach(function (otro) {
          if (otro !== item) otro.open = false;
        });
      },
      true
    );

    document.addEventListener('shopify:block:select', function (evento) {
      const item = evento.target;
      if (item instanceof HTMLDetailsElement && item.classList.contains('faq-columnas-item')) {
        item.open = true;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fichaproducto"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('ficha-producto')) return;

    class FichaProducto extends HTMLElement {
      connectedCallback() {
        const datos = this.querySelector('[data-variantes]');
        this.variantes = datos ? JSON.parse(datos.textContent) : [];
        this.formato = this.dataset.formatoMoneda || '{{amount}}';
        this.imagenPrincipal = this.querySelector('[data-imagen-principal]');
        this.miniaturas = Array.from(this.querySelectorAll('.fp-miniatura'));
        this.entradasOpcion = Array.from(this.querySelectorAll('.fp-opcion-input'));
        this.entradasPaquete = Array.from(this.querySelectorAll('.fp-paquete-input'));
        this.contenedorPaquetes = this.querySelector('.fp-paquetes');
        this.regalos = this.querySelector('[data-regalos]');
        this.formulario = this.querySelector('.fp-formulario');
        this.campoVariante = this.querySelector('[data-variante-id]');
        this.campoCantidad = this.querySelector('[data-cantidad]');
        this.botonCompra = this.querySelector('[data-boton-compra]');
        this.textoBoton = this.querySelector('[data-boton-texto]');
        this.error = this.querySelector('[data-error]');
        this.conRegalos = false;

        const idInicial = this.campoVariante ? Number(this.campoVariante.value) : null;
        this.varianteActual = this.variantes.find((variante) => variante.id === idInicial) || this.variantes[0];

        this.miniaturas.forEach((miniatura) => {
          miniatura.addEventListener('click', () => this.mostrarMedio(miniatura));
        });
        this.entradasOpcion.forEach((entrada) => {
          entrada.addEventListener('change', () => this.alCambiarOpcion());
        });
        this.entradasPaquete.forEach((entrada) => {
          entrada.addEventListener('change', () => this.actualizarPaquetes());
        });
        if (this.formulario) {
          this.formulario.addEventListener('submit', (evento) => this.agregarAlCarrito(evento));
        }

        if (this.entradasPaquete.length && !this.entradasPaquete.some((entrada) => entrada.checked)) {
          this.entradasPaquete[0].checked = true;
        }

        this.actualizarPaquetes();
        this.actualizarEntrega();
      }

      formatearDinero(centavos) {
        const coincidencia = this.formato.match(/\{\{\s*(\w+)\s*\}\}/);
        const tipo = coincidencia ? coincidencia[1] : 'amount';
        const formatear = (decimales, separadorMiles, separadorDecimal) => {
          const fijo = (centavos / 100).toFixed(decimales);
          const partes = fijo.split('.');
          const entero = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, separadorMiles);
          return partes[1] ? entero + separadorDecimal + partes[1] : entero;
        };
        let valor;

        switch (tipo) {
          case 'amount_no_decimals':
            valor = formatear(0, ',', '.');
            break;
          case 'amount_with_comma_separator':
            valor = formatear(2, '.', ',');
            break;
          case 'amount_no_decimals_with_comma_separator':
            valor = formatear(0, '.', ',');
            break;
          case 'amount_with_apostrophe_separator':
            valor = formatear(2, "'", '.');
            break;
          default:
            valor = formatear(2, ',', '.');
        }

        return this.formato.replace(/\{\{\s*\w+\s*\}\}/, valor);
      }

      mostrarMedio(miniatura) {
        if (!this.imagenPrincipal || !miniatura) return;
        this.imagenPrincipal.src = miniatura.dataset.src;
        this.imagenPrincipal.srcset = miniatura.dataset.srcset;
        this.imagenPrincipal.alt = miniatura.dataset.alt;
        this.miniaturas.forEach((otra) => {
          otra.setAttribute('aria-current', otra === miniatura ? 'true' : 'false');
        });
      }

      alCambiarOpcion() {
        const valores = [];

        this.entradasOpcion.forEach((entrada) => {
          if (entrada.checked) valores[Number(entrada.dataset.indiceOpcion)] = entrada.value;
        });

        valores.forEach((valor, indice) => {
          const etiqueta = this.querySelector(`[data-valor-opcion="${indice}"]`);
          if (etiqueta) etiqueta.textContent = valor;
        });

        const variante = this.variantes.find((posible) => posible.options.every((opcion, indice) => opcion === valores[indice]));
        this.varianteActual = variante || null;

        if (variante) {
          if (this.campoVariante) this.campoVariante.value = variante.id;
          window.history.replaceState({}, '', `${this.dataset.urlProducto}?variant=${variante.id}`);

          if (variante.media) {
            const miniatura = this.miniaturas.find((posible) => Number(posible.dataset.medioId) === variante.media);
            if (miniatura) this.mostrarMedio(miniatura);
          }
        }

        this.actualizarPrecioUnitario();
        this.actualizarPaquetes();
        this.actualizarBoton();
      }

      actualizarPrecioUnitario() {
        const variante = this.varianteActual;
        const enOferta = Boolean(variante && variante.compare_at_price > variante.price);
        const precio = this.querySelector('[data-precio-unitario]');
        const comparacion = this.querySelector('[data-comparacion-unitaria]');

        if (variante && precio) precio.textContent = this.formatearDinero(variante.price);
        if (comparacion) {
          comparacion.hidden = !enOferta;
          if (enOferta) comparacion.textContent = this.formatearDinero(variante.compare_at_price);
        }

        this.querySelectorAll('[data-solo-oferta]').forEach((etiqueta) => {
          etiqueta.hidden = !enOferta;
        });
      }

      actualizarPaquetes() {
        const variante = this.varianteActual;

        if (variante) {
          const precio = variante.price;
          const base = variante.compare_at_price > precio ? variante.compare_at_price : precio; // Reference value for the crossed-out display only.

          this.entradasPaquete.forEach((entrada) => {
            const pagar = Number(entrada.dataset.pagar) || 1;
            const total = Math.max(Number(entrada.dataset.total) || 1, pagar);
            const etiqueta = this.querySelector(`label[for="${entrada.id}"]`);
            if (!etiqueta) return;

            const precioTotal = precio * pagar;
            const comparacionTotal = base * total;
            const campoPrecio = etiqueta.querySelector('[data-precio]');
            const campoComparacion = etiqueta.querySelector('[data-comparacion]');
            const campoAhorro = etiqueta.querySelector('[data-ahorro]');

            if (campoPrecio) campoPrecio.textContent = this.formatearDinero(precioTotal);
            if (campoComparacion) {
              campoComparacion.textContent = this.formatearDinero(comparacionTotal);
              campoComparacion.hidden = comparacionTotal <= precioTotal;
            }
            if (campoAhorro) {
              const ahorro = comparacionTotal > precioTotal ? Math.round(100 - (precioTotal * 100) / comparacionTotal) : 0;
              campoAhorro.textContent = (campoAhorro.dataset.plantilla || '').replace('[porcentaje]', ahorro);
              campoAhorro.hidden = ahorro <= 0;
            }
          });
        }

        const elegido = this.entradasPaquete.find((entrada) => entrada.checked);
        let cantidad = 1;
        let conRegalos = false;

        if (elegido) {
          cantidad = Math.max(Number(elegido.dataset.total) || 1, Number(elegido.dataset.pagar) || 1);
          const desde = this.contenedorPaquetes ? this.contenedorPaquetes.dataset.regalosDesde : 'ninguno';
          conRegalos = desde !== 'ninguno' && Number(elegido.value) >= Number(desde);
          const nombre = this.querySelector('[data-paquete-nombre]');
          if (nombre) nombre.textContent = elegido.dataset.titulo;
        }

        if (this.campoCantidad) this.campoCantidad.value = cantidad;
        if (this.regalos) this.regalos.hidden = !conRegalos;
        this.conRegalos = conRegalos && Boolean(this.regalos);
      }

      actualizarBoton() {
        if (!this.botonCompra || !this.textoBoton) return;
        const variante = this.varianteActual;

        if (!variante) {
          this.botonCompra.disabled = true;
          this.textoBoton.textContent = this.dataset.textoNoDisponible;
        } else if (!variante.available) {
          this.botonCompra.disabled = true;
          this.textoBoton.textContent = this.dataset.textoAgotado;
        } else {
          this.botonCompra.disabled = false;
          this.textoBoton.textContent = this.botonCompra.dataset.textoAgregar;
        }
      }

      actualizarEntrega() {
        const contenedor = this.querySelector('[data-entrega]');
        if (!contenedor) return;

        const minimo = Number(contenedor.dataset.diasMin) || 0;
        const maximo = Math.max(Number(contenedor.dataset.diasMax) || minimo, minimo);
        const soloHabiles = contenedor.dataset.habiles === 'true';
        const sumarDias = (dias) => {
          const fecha = new Date();
          let restantes = dias;
          while (restantes > 0) {
            fecha.setDate(fecha.getDate() + 1);
            const diaSemana = fecha.getDay();
            if (!soloHabiles || (diaSemana !== 0 && diaSemana !== 6)) restantes -= 1;
          }
          return fecha;
        };
        const formato = new Intl.DateTimeFormat(document.documentElement.lang || undefined, {
          weekday: 'short',
          month: 'short',
          day: 'numeric'
        });
        const destino = contenedor.querySelector('[data-fecha-entrega]');
        const desde = formato.format(sumarDias(minimo));
        const hasta = formato.format(sumarDias(maximo));

        if (destino) destino.textContent = minimo === maximo ? desde : `${desde} – ${hasta}`;
      }

      // Standard Shopify product forms use FormData. Prefer that for a single
      // variant; if Shopify's Ajax inventory cache incorrectly responds 422,
      // retry with Shopify's official JSON items endpoint as a safe fallback.
      // Only retry failed responses: a confirmed add is never submitted twice.
      async enviarArticulos(articulos) {
        const unProducto = articulos.length === 1;
        const metodos = unProducto
          ? ['formulario', 'json', 'formulario', 'json']
          : ['json', 'json', 'json', 'json'];
        const pausas = [0, 1000, 2000, 3500];
        let resultado;

        for (let intento = 0; intento < metodos.length; intento += 1) {
          if (intento > 0) {
            await new Promise((resolver) => window.setTimeout(resolver, pausas[intento]));
          }

          const usarFormulario = metodos[intento] === 'formulario';
          const opciones = {
            method: 'POST',
            credentials: 'same-origin',
            headers: { Accept: 'application/json' }
          };

          if (usarFormulario) {
            // This includes Shopify's native form fields and the bundle quantity.
            const datosFormulario = new FormData(this.formulario);
            datosFormulario.set('id', String(articulos[0].id));
            datosFormulario.set('quantity', String(articulos[0].quantity));
            opciones.body = datosFormulario;
          } else {
            opciones.headers['Content-Type'] = 'application/json';
            opciones.body = JSON.stringify({ items: articulos });
          }

          const respuesta = await fetch(this.dataset.urlAgregar, opciones);
          const datos = await respuesta.json().catch(() => ({
            message: 'Unable to add this item to your basket. Please try again.'
          }));
          const detalle = String(datos.description || datos.message || '');
          const errorDisponibilidad = respuesta.status === 422 && /already sold out/i.test(detalle);

          resultado = { correcto: respuesta.ok, datos, errorDisponibilidad };
          if (respuesta.ok || !errorDisponibilidad || !this.varianteActual || !this.varianteActual.available) {
            return resultado;
          }
        }

        return resultado;
      }

      agregarAlCarrito(evento) {
        evento.preventDefault();
        const variante = this.varianteActual;
        if (!variante || !variante.available || !this.botonCompra) return;

        const articulos = [{ id: variante.id, quantity: Number(this.campoCantidad && this.campoCantidad.value) || 1 }];

        if (this.conRegalos && this.regalos) {
          this.regalos.querySelectorAll('[data-variante-regalo]').forEach((regalo) => {
            articulos.push({ id: Number(regalo.dataset.varianteRegalo), quantity: 1 });
          });
        }

        this.botonCompra.disabled = true;
        this.botonCompra.classList.add('fp-boton--cargando');
        if (this.error) this.error.hidden = true;

        this.enviarArticulos(articulos)
          .then(({ correcto, datos, errorDisponibilidad }) => {
            if (!correcto) {
              if (errorDisponibilidad && variante.available) {
                throw new Error('We could not add this item to your basket. Please try again in a private browser window or contact support@saintslabeluk.com.');
              }
              throw new Error(datos.description || datos.message || 'Unable to add this item to your basket.');
            }
            const raiz = this.dataset.urlCarrito.replace(/cart\/?$/, '');
            window.location.href = this.dataset.destino === 'checkout' ? `${raiz}checkout` : this.dataset.urlCarrito;
          })
          .catch((problema) => {
            if (this.error) {
              this.error.textContent = problema.message;
              this.error.hidden = false;
            }
            this.botonCompra.disabled = false;
            this.botonCompra.classList.remove('fp-boton--cargando');
          });
      }
    }

    customElements.define('ficha-producto', FichaProducto);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('encabezado-principal')) return;

    class EncabezadoPrincipal extends HTMLElement {
      connectedCallback() {
        this.seccion = this.closest('.shopify-section');
        this.modoFijo = this.dataset.modoFijo;
        this.botonAbrir = this.querySelector('.encabezado-principal-boton-hamburguesa');
        this.botonCerrar = this.querySelector('.encabezado-principal-cajon-cerrar');
        this.capa = this.querySelector('.encabezado-principal-capa');
        this.cajon = this.querySelector('.encabezado-principal-cajon');
        this.ultimoScroll = window.pageYOffset;
        this.consultaEscritorio = window.matchMedia('(min-width: 990px)');

        this.alAbrir = this.abrirCajon.bind(this);
        this.alCerrar = this.cerrarCajon.bind(this);
        this.alPresionarTecla = this.manejarTecla.bind(this);
        this.alHacerScroll = this.manejarScroll.bind(this);
        this.alCambiarTamano = this.actualizarAltura.bind(this);
        this.alCambiarConsulta = this.manejarCambioConsulta.bind(this);

        if (this.botonAbrir) this.botonAbrir.addEventListener('click', this.alAbrir);
        if (this.botonCerrar) this.botonCerrar.addEventListener('click', this.alCerrar);
        if (this.capa) this.capa.addEventListener('click', this.alCerrar);
        document.addEventListener('keydown', this.alPresionarTecla);
        this.consultaEscritorio.addEventListener('change', this.alCambiarConsulta);

        if ('ResizeObserver' in window) {
          this.observadorTamano = new ResizeObserver(this.alCambiarTamano);
          this.observadorTamano.observe(this);
        } else {
          window.addEventListener('resize', this.alCambiarTamano);
        }

        if (this.modoFijo === 'ocultar_al_bajar') {
          window.addEventListener('scroll', this.alHacerScroll, { passive: true });
          this.observarNotificacion();
        }

        this.actualizarAltura();
      }

      disconnectedCallback() {
        document.removeEventListener('keydown', this.alPresionarTecla);
        window.removeEventListener('scroll', this.alHacerScroll);
        window.removeEventListener('resize', this.alCambiarTamano);
        this.consultaEscritorio.removeEventListener('change', this.alCambiarConsulta);
        if (this.observadorTamano) this.observadorTamano.disconnect();
        if (this.observadorNotificacion) this.observadorNotificacion.disconnect();
        document.body.classList.remove('encabezado-principal-sin-scroll');
        this.mostrarSeccion();
      }

      actualizarAltura() {
        const altura = this.querySelector('.encabezado-principal-barra').offsetHeight;
        document.documentElement.style.setProperty('--header-height', altura + 'px');
        if (this.seccion) this.seccion.style.setProperty('--encabezado-principal-altura', altura + 'px');
      }

      observarNotificacion() {
        const notificacion = this.querySelector('#cart-notification');
        if (!notificacion || !('MutationObserver' in window)) return;

        this.observadorNotificacion = new MutationObserver(() => {
          if (notificacion.classList.contains('active')) this.mostrarSeccion();
        });

        this.observadorNotificacion.observe(notificacion, { attributes: true, attributeFilter: ['class'] });
      }

      mostrarSeccion() {
        if (this.seccion) this.seccion.classList.remove('encabezado-principal-seccion-oculta');
      }

      ocultarSeccion() {
        if (this.seccion) this.seccion.classList.add('encabezado-principal-seccion-oculta');
      }

      manejarScroll() {
        const actual = window.pageYOffset;
        const altura = this.offsetHeight;

        if (this.classList.contains('encabezado-principal--cajon-abierto')) {
          this.ultimoScroll = actual;
          return;
        }

        if (actual > this.ultimoScroll && actual > altura) {
          this.ocultarSeccion();
        } else if (actual < this.ultimoScroll) {
          this.mostrarSeccion();
        }

        this.ultimoScroll = actual;
      }

      abrirCajon() {
        if (!this.cajon) return;
        this.mostrarSeccion();
        this.classList.add('encabezado-principal--cajon-abierto');
        this.cajon.setAttribute('aria-hidden', 'false');
        if (this.botonAbrir) this.botonAbrir.setAttribute('aria-expanded', 'true');
        document.body.classList.add('encabezado-principal-sin-scroll');
        if (this.botonCerrar) this.botonCerrar.focus();
      }

      cerrarCajon() {
        if (!this.cajon || !this.classList.contains('encabezado-principal--cajon-abierto')) return;
        this.classList.remove('encabezado-principal--cajon-abierto');
        this.cajon.setAttribute('aria-hidden', 'true');
        if (this.botonAbrir) {
          this.botonAbrir.setAttribute('aria-expanded', 'false');
          this.botonAbrir.focus();
        }
        document.body.classList.remove('encabezado-principal-sin-scroll');
      }

      manejarTecla(evento) {
        if (evento.key === 'Escape') this.cerrarCajon();
      }

      manejarCambioConsulta(evento) {
        if (evento.matches) this.cerrarCajon();
        this.actualizarAltura();
      }
    }

    customElements.define('encabezado-principal', EncabezadoPrincipal);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["historia-carrusel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('historia-carrusel')) return;

    class HistoriaCarrusel extends HTMLElement {
      connectedCallback() {
        this.pista = this.querySelector('.historia-carrusel-pista');
        this.diapositivas = Array.from(this.querySelectorAll('.historia-carrusel-diapositiva'));
        this.botonAnterior = this.querySelector('.historia-carrusel-flecha--anterior');
        this.botonSiguiente = this.querySelector('.historia-carrusel-flecha--siguiente');
        this.puntos = Array.from(this.querySelectorAll('.historia-carrusel-punto'));
        this.bucle = this.dataset.bucle === 'true';
        this.intervalo = parseInt(this.dataset.intervalo, 10) || 5000;
        this.movimientoReducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.modoEditor = Boolean(window.Shopify && window.Shopify.designMode);
        this.automatico = this.dataset.automatico === 'true' && !this.movimientoReducido && !this.modoEditor;
        this.indice = 0;
        this.cuadroPendiente = null;

        if (!this.pista || this.diapositivas.length === 0) return;

        this.alAnterior = () => this.irA(this.indice - 1);
        this.alSiguiente = () => this.irA(this.indice + 1);
        this.alDesplazar = this.manejarDesplazamiento.bind(this);
        this.alTecla = this.manejarTecla.bind(this);
        this.alPausar = this.detenerAutomatico.bind(this);
        this.alReanudar = this.iniciarAutomatico.bind(this);
        this.alSeleccionarBloque = this.manejarSeleccionBloque.bind(this);
        this.alDeseleccionarBloque = this.iniciarAutomatico.bind(this);

        if (this.botonAnterior) this.botonAnterior.addEventListener('click', this.alAnterior);
        if (this.botonSiguiente) this.botonSiguiente.addEventListener('click', this.alSiguiente);
        this.puntos.forEach((punto) => {
          punto.addEventListener('click', () => this.irA(parseInt(punto.dataset.indice, 10)));
        });
        this.pista.addEventListener('scroll', this.alDesplazar, { passive: true });
        this.pista.addEventListener('keydown', this.alTecla);
        this.addEventListener('mouseenter', this.alPausar);
        this.addEventListener('mouseleave', this.alReanudar);
        this.addEventListener('focusin', this.alPausar);
        this.addEventListener('focusout', this.alReanudar);
        document.addEventListener('shopify:block:select', this.alSeleccionarBloque);
        document.addEventListener('shopify:block:deselect', this.alDeseleccionarBloque);

        this.actualizarEstado();
        this.iniciarAutomatico();
      }

      disconnectedCallback() {
        this.detenerAutomatico();
        document.removeEventListener('shopify:block:select', this.alSeleccionarBloque);
        document.removeEventListener('shopify:block:deselect', this.alDeseleccionarBloque);
        if (this.cuadroPendiente) cancelAnimationFrame(this.cuadroPendiente);
      }

      irA(nuevoIndice) {
        const total = this.diapositivas.length;
        let destino = nuevoIndice;

        if (this.bucle) {
          destino = (nuevoIndice + total) % total;
        } else {
          destino = Math.max(0, Math.min(total - 1, nuevoIndice));
        }

        this.indice = destino;
        this.pista.scrollTo({
          left: this.diapositivas[destino].offsetLeft,
          behavior: this.movimientoReducido ? 'auto' : 'smooth'
        });
        this.actualizarEstado();
      }

      manejarDesplazamiento() {
        if (this.cuadroPendiente) return;

        this.cuadroPendiente = requestAnimationFrame(() => {
          this.cuadroPendiente = null;
          const ancho = this.pista.clientWidth || 1;
          const calculado = Math.round(this.pista.scrollLeft / ancho);

          if (calculado !== this.indice) {
            this.indice = Math.max(0, Math.min(this.diapositivas.length - 1, calculado));
            this.actualizarEstado();
          }
        });
      }

      manejarTecla(evento) {
        if (evento.key === 'ArrowLeft') {
          evento.preventDefault();
          this.irA(this.indice - 1);
        } else if (evento.key === 'ArrowRight') {
          evento.preventDefault();
          this.irA(this.indice + 1);
        }
      }

      manejarSeleccionBloque(evento) {
        const posicion = this.diapositivas.indexOf(evento.target);
        if (posicion === -1) return;
        this.detenerAutomatico();
        this.irA(posicion);
      }

      actualizarEstado() {
        const total = this.diapositivas.length;

        this.puntos.forEach((punto, posicion) => {
          punto.setAttribute('aria-current', posicion === this.indice ? 'true' : 'false');
        });

        if (!this.bucle) {
          if (this.botonAnterior) this.botonAnterior.disabled = this.indice === 0;
          if (this.botonSiguiente) this.botonSiguiente.disabled = this.indice === total - 1;
        }
      }

      iniciarAutomatico() {
        if (!this.automatico || this.temporizador || this.diapositivas.length < 2) return;

        this.temporizador = setInterval(() => {
          const siguiente = this.indice + 1;
          if (!this.bucle && siguiente >= this.diapositivas.length) {
            this.irA(0);
          } else {
            this.irA(siguiente);
          }
        }, this.intervalo);
      }

      detenerAutomatico() {
        if (this.temporizador) {
          clearInterval(this.temporizador);
          this.temporizador = null;
        }
      }
    }

    customElements.define('historia-carrusel', HistoriaCarrusel);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["muroresenas"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('resenas-muro')) return;

    class ResenasMuro extends HTMLElement {
      connectedCallback() {
        this.porPagina = parseInt(this.dataset.porPagina, 10) || 10;
        this.boton = this.querySelector('[data-cargar-mas]');
        if (!this.boton) return;

        this.alCargar = this.cargarMas.bind(this);
        this.boton.addEventListener('click', this.alCargar);
        this.actualizarBoton();
      }

      cargarMas() {
        const ocultas = Array.from(this.querySelectorAll('[data-resena][hidden]'));
        ocultas.slice(0, this.porPagina).forEach((resena) => {
          resena.hidden = false;
        });
        this.actualizarBoton();
      }

      actualizarBoton() {
        const quedan = this.querySelectorAll('[data-resena][hidden]').length;
        this.boton.hidden = quedan === 0;
      }
    }

    customElements.define('resenas-muro', ResenasMuro);

    document.addEventListener('shopify:block:select', function (evento) {
      const item = evento.target;
      if (item && item.matches && item.matches('[data-resena]')) item.hidden = false;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popupdescuento"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('ventana-descuento')) return;

    const leer = (clave) => {
      try {
        return window.localStorage.getItem(clave);
      } catch (error) {
        return null;
      }
    };

    const guardar = (clave, valor) => {
      try {
        window.localStorage.setItem(clave, valor);
      } catch (error) {}
    };

    const leerSesion = (clave) => {
      try {
        return window.sessionStorage.getItem(clave);
      } catch (error) {
        return null;
      }
    };

    const guardarSesion = (clave, valor) => {
      try {
        if (valor === null) {
          window.sessionStorage.removeItem(clave);
        } else {
          window.sessionStorage.setItem(clave, valor);
        }
      } catch (error) {}
    };

    const ESPERA_MAXIMA_PROGRAMADA = 2 * 60 * 60 * 1000;

    class VentanaDescuento extends HTMLElement {
      connectedCallback() {
        this.seccion = this.dataset.seccion;
        this.dialogo = this.querySelector('.ventana-descuento-dialogo');
        this.formulario = this.querySelector('.ventana-descuento-formulario');
        this.exito = this.querySelector('[data-exito]');
        this.modoEditor = Boolean(window.Shopify && window.Shopify.designMode);
        this.claveCerrado = 'ventana-descuento-cerrado';
        this.claveSuscrito = 'ventana-descuento-suscrito';
        this.claveEnviado = 'ventana-descuento-enviado';
        this.minutosTrasCerrar = Number(this.dataset.minutosTrasCerrar) || 0;
        this.diasTrasSuscripcion = Number(this.dataset.diasTrasSuscripcion) || 0;

        this.alTecla = this.manejarTecla.bind(this);

        this.querySelectorAll('[data-cerrar]').forEach((boton) => {
          boton.addEventListener('click', () => this.cerrar());
        });

        const botonCopiar = this.querySelector('[data-copiar]');
        if (botonCopiar) botonCopiar.addEventListener('click', () => this.copiarCodigo(botonCopiar));

        if (this.formulario && !this.exito) {
          this.formulario.addEventListener('submit', () => guardarSesion(this.claveEnviado, '1'));
        }

        if (this.modoEditor) {
          this.alSeleccionar = (evento) => {
            if (evento.detail && evento.detail.sectionId === this.seccion) this.abrir();
          };
          this.alDeseleccionar = (evento) => {
            if (evento.detail && evento.detail.sectionId === this.seccion) this.cerrar(true);
          };
          document.addEventListener('shopify:section:select', this.alSeleccionar);
          document.addEventListener('shopify:section:deselect', this.alDeseleccionar);
          return;
        }

        if (this.exito && leerSesion(this.claveEnviado)) {
          guardarSesion(this.claveEnviado, null);
          guardar(this.claveSuscrito, String(Date.now()));
          this.abrir();
          this.aplicarDescuento();
          return;
        }

        if (this.dataset.mostrarMovil !== 'true' && window.matchMedia('(max-width: 749px)').matches) return;

        this.programar(this.tiempoRestante());
      }

      disconnectedCallback() {
        if (this.temporizador) window.clearTimeout(this.temporizador);
        document.removeEventListener('keydown', this.alTecla);
        if (this.alSeleccionar) document.removeEventListener('shopify:section:select', this.alSeleccionar);
        if (this.alDeseleccionar) document.removeEventListener('shopify:section:deselect', this.alDeseleccionar);
        document.body.classList.remove('ventana-descuento-sin-scroll');
      }

      retrasoAleatorio() {
        const minimo = Number(this.dataset.retrasoMinimo) || 0;
        const maximo = Math.max(Number(this.dataset.retrasoMaximo) || minimo, minimo);
        return (minimo + Math.random() * (maximo - minimo)) * 1000;
      }

      tiempoRestante() {
        const ahora = Date.now();
        let restante = 0;

        const suscritoEn = Number(leer(this.claveSuscrito));
        if (suscritoEn && this.diasTrasSuscripcion > 0) {
          restante = Math.max(restante, suscritoEn + this.diasTrasSuscripcion * 86400000 - ahora);
        }

        const cerradoEn = Number(leer(this.claveCerrado));
        if (cerradoEn && this.minutosTrasCerrar > 0) {
          restante = Math.max(restante, cerradoEn + this.minutosTrasCerrar * 60000 - ahora);
        }

        return restante;
      }

      programar(restante) {
        if (this.temporizador) window.clearTimeout(this.temporizador);
        if (restante > ESPERA_MAXIMA_PROGRAMADA) return;

        const espera = restante > 0 ? restante : this.retrasoAleatorio();
        this.temporizador = window.setTimeout(() => {
          if (this.tiempoRestante() <= 0) {
            this.abrir();
          } else {
            this.programar(this.tiempoRestante());
          }
        }, espera);
      }

      abrir() {
        if (this.classList.contains('ventana-descuento--abierta')) return;
        this.elementoPrevio = document.activeElement;
        this.classList.add('ventana-descuento--abierta');
        document.body.classList.add('ventana-descuento-sin-scroll');
        document.addEventListener('keydown', this.alTecla);

        const campo = this.querySelector('.ventana-descuento-campo');
        window.setTimeout(() => (campo || this.dialogo).focus(), 50);
      }

      cerrar(desdeEditor) {
        if (!this.classList.contains('ventana-descuento--abierta')) return;
        this.classList.remove('ventana-descuento--abierta');
        document.body.classList.remove('ventana-descuento-sin-scroll');
        document.removeEventListener('keydown', this.alTecla);

        if (this.elementoPrevio && this.elementoPrevio.focus) this.elementoPrevio.focus();
        if (desdeEditor || this.modoEditor) return;

        if (this.exito) {
          this.exito = null;
          this.programar(this.tiempoRestante());
          return;
        }

        guardar(this.claveCerrado, String(Date.now()));
        this.programar(this.tiempoRestante());
      }

      manejarTecla(evento) {
        if (evento.key === 'Escape') this.cerrar();
      }

      copiarCodigo(boton) {
        const codigo = this.dataset.codigo;
        if (!codigo) return;

        const confirmar = () => {
          boton.textContent = this.dataset.textoCopiado;
        };

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(codigo).then(confirmar).catch(() => {});
        }
      }

      aplicarDescuento() {
        const codigo = this.dataset.codigo;
        if (this.dataset.aplicar !== 'true' || !codigo) return;
        const raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(`${raiz}discount/${encodeURIComponent(codigo)}`, { credentials: 'same-origin' }).catch(() => {});
      }
    }

    customElements.define('ventana-descuento', VentanaDescuento);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valoracion"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (document.documentElement.dataset.preguntasFrecuentesListo) return;
    document.documentElement.dataset.preguntasFrecuentesListo = 'true';

    document.addEventListener(
      'toggle',
      function (evento) {
        const item = evento.target;
        if (!(item instanceof HTMLDetailsElement) || !item.classList.contains('preguntas-frecuentes-item') || !item.open) return;

        const seccion = item.closest('.preguntas-frecuentes');
        if (!seccion || seccion.dataset.soloUno !== 'true') return;

        seccion.querySelectorAll('.preguntas-frecuentes-item[open]').forEach(function (otro) {
          if (otro !== item) otro.open = false;
        });
      },
      true
    );

    document.addEventListener('shopify:block:select', function (evento) {
      const item = evento.target;
      if (item instanceof HTMLDetailsElement && item.classList.contains('preguntas-frecuentes-item')) {
        item.open = true;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
